module.exports = __webpack_public_path__ + "static/img/13.2.190b449.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/3/zh/13.2.png
// module id = hPsG
// module chunks = 0